import { render, staticRenderFns } from "./WNav.vue?vue&type=template&id=604638ba&scoped=true"
import script from "./WNav.vue?vue&type=script&lang=js"
export * from "./WNav.vue?vue&type=script&lang=js"
import style0 from "./WNav.vue?vue&type=style&index=0&id=604638ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604638ba",
  null
  
)

export default component.exports